import React from 'react'
import ProjectPanel from "./components/ProjectPanel";
import ProfilePanel from "./components/ProfilePanel";
import AvailabilityPanel from "./components/AvailabilityPanel";
import ContractsPanel from "./components/ContractsPanel";
import Page from "../Page";
import WrippleEffectPanel from '../talent-dashboard/components/WrippleEffectPanel';
import JobsPreferencesPanel from "./components/JobsPreferencesPanel";
import ClientPanel from './components/ClientPanel';
import TeamsPanel from './components/TeamsPanel';
import { useAuth } from '../../providers/AuthProvider';
import { Link } from "react-router-dom";

export default class TalentDashboard extends Page {

    static path = '/dashboard';

    constructor(props, context) {
        super(props, context);
        let hasCompletedProfile = context?.auth?.hasCompletedProfile()

        this.state = {
            ...this.state,
            hasTodoItems: context?.auth?.mustSignAgreement() || !hasCompletedProfile,
            hasCompletedProfile,
            isLoading: true
        }
    }

    async componentDidMount() {
        await super.componentDidMount();

        let stats = await this.context?.auth?.getTalentUserStats();

        if (stats) {
            return this.promisedState({ isLoading: false, stats })
        }
        return this.promisedState({ isLoading: false });
    }

    render() {
        let {
            isLoading,
            stats
        } = this.state;

        const isSupplier = this.context.auth?.isTalentSupplierResource();
        const isClientInvitedAndNotOnMarketplace = this.context.auth?.isClientInvitedResource({ is_on_talent_marketplace: false });

        if (isClientInvitedAndNotOnMarketplace) {
            return (
                <div className="talent-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">
                    <ProfilePanel
                        isLoading={isLoading}
                        colClass="md:w-6/12 xl:basis-[unset] xl:!w-4/12"
                    />

                    {/* <div className="w-full mb-6 order-2 sm:px-3 md:order-3 xl:order-4">
                        <WrippleEffectPanel />
                    </div> */}

                    <ProjectPanel
                        isLoading={isLoading}
                        opportunities={stats?.opportunities}
                        totalUpdates={stats?.total_new_invited_talent_opps}
                        lastViewed={stats?.last_viewed_talent_opps}
                        colClass="order-3 md:order-2 md:w-6/12 xl:w-4/12"
                    />

                    <ClientPanel
                        colClass="order-4 md:order-3 md:w-6/12 xl:w-4/12"
                        title="Network"
                    />

                </div>
            )
        }

        if (isSupplier) {
            return (
                <div className="talent-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">
                    <ProfilePanel isLoading={isLoading} colClass="md:w-6/12 xl:basis-auto xl:!w-4/12" />

                    <div className="w-full mb-6 order-2 sm:px-3 md:order-3 xl:order-4">
                        <WrippleEffectPanel />
                    </div>

                    <ProjectPanel
                        isLoading={isLoading}
                        opportunities={stats?.opportunities}
                        totalUpdates={stats?.total_new_invited_talent_opps}
                        lastViewed={stats?.last_viewed_talent_opps}
                        colClass="order-3 md:order-2 md:w-6/12 xl:w-4/12"
                    />

                    <TeamsPanel
                        isLoading={isLoading}
                        teams={stats?.teams}
                        colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12 xl:order-3"
                    />
                    {/*<DashboardPanel
                        colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12 xl:order-3"
                        columnOrdering={{xl: 6, lg: 6, md: 6, sm: 6, xs: 6}}
                        columnProps={{sm: 12}}
                        panelClass="min-width-unset"
                        isLoading={isLoading}
                        inactiveMessage={'Form teams to deliver projects with people you already know and love working with.'}
                        title={'Collectives'}
                        disabled={this.context.auth?.mustSignAgreement()}
                        inactive={true}
                    />*/}
                </div>
            )
        }

        return (
            <div className="talent-portal-dashboard px-3 py-4 sm:px-5 sm:py-7 md:py-10">

                <PendingProfile colClass="max-w-[calc(100vw_-_1.5rem)] w-full order-1 md:order-1 xl:order-1 mb-6" />

                <ProfilePanel isLoading={isLoading} />

                <AvailabilityPanel isLoading={isLoading} colClass="max-w-[calc(100vw_-_1.5rem)] w-full mb-6 order-3 sm:px-3 md:w-7/12 md:order-2 xl:w-7/12 xl:basis-[50%] xl:max-w-[58.33333%]" />

                <JobsPreferencesPanel stats={stats} isLoading={isLoading} />

                <div className="max-w-[calc(100vw_-_1.5rem)] w-full order-2 sm:px-3 md:order-3 xl:order-4 mb-6">
                    <WrippleEffectPanel />
                </div>

                <ProjectPanel
                    isLoading={isLoading}
                    opportunities={stats?.opportunities}
                    totalUpdates={stats?.total_new_invited_talent_opps}
                    lastViewed={stats?.last_viewed_talent_opps}
                    colClass="max-w-[calc(100vw_-_1.5rem)] md:w-6/12 xl:w-4/12"
                />

                <ContractsPanel
                    isLoading={isLoading}
                    contracts={stats?.contracts}
                    totalUpdates={stats?.total_new_contracts}
                    lastViewed={stats?.last_viewed_talent_contracts}
                />

                {/* <DashboardPanel
                    colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12"
                    columnOrdering={{xl: 6, lg: 6, md: 6, sm: 6, xs: 6}}
                    columnProps={{sm: 12}}
                    panelClass="min-width-unset"
                    isLoading={isLoading}
                    inactiveMessage={'Form teams to deliver projects with people you already know and love working with.'}
                    title={'Collectives'}
                    disabled={this.context.auth?.mustSignAgreement()}
                    inactive={true}
                /> */}

                <TeamsPanel
                    isLoading={isLoading}
                    teams={stats?.teams}
                    colClass="order-6 mb-6 w-full sm:px-3 md:w-6/12 xl:w-4/12"
                />
            </div>
        )
    }

    renderLastUpdated(lastUpdated) {
        if (!TB.isInteger(lastUpdated)) {
            return null;
        }

        return (
            <div className="header-last-updated">
                <p className={lastUpdated > 30 ? 'text-danger' : ''}>
                    <i className="fas fa-clock" />
                    &nbsp; {`${lastUpdated} day${(lastUpdated === 1) ? '' : 's'} ago`}
                </p>
            </div>
        )
    }
}


const PendingProfile = ({ colClass }) => {
    const { auth } = useAuth();

    if (!!auth.talent_profile_approved_at) return null;

    let status;
    if (auth.isPendingProfileApproved()) { // pending
        status = {
            className: 'bg-orange-100 text-yellow-800',
            // title: 'Your profile is pending approval',
            title: 'Your profile has been submitted and is pending approval. You will receive update once it has been reviewed',
            icon: 'fas fa-history',
            subTitle: 'Pending Approval',
        }
    } else if (auth.isProfileApproved()) {
        status = {
            className: 'bg-green-100 text-green-800',
            title: 'Your profile is approved',
            icon: 'fas fa-check-circle text-wripplePrimaryPaleGreen',
        }
    } else if (auth.latest_appeal) {

        if (auth.latest_appeal.is_rejected) {
            status = {
                className: 'bg-red-100 text-red-800',
                title: 'Your appeal is not approved at this time',
                icon: 'fas fa-times-circle text-wripplePrimaryPaleRed',
                subTitle: 'Rejected',
            }
        } else {
            status = {
                className: 'bg-orange-100 text-red-800',
                title: 'Your profile approval appeal has been submitted and is pending',
                icon: 'fas fa-history',
                subTitle: 'Appeal Sent',
            }
        }
    } else if (auth.isProfileRejected()) {
        status = {
            className: 'bg-red-100 text-red-800',
            title: 'Your profile is not approved. View profile for more options',
            icon: 'fas fa-times-circle text-wripplePrimaryPaleRed',
            subTitle: 'Rejected',
        }
    } else {
        status = {
            // className: !auth.hasCompletedProfile() ? 'bg-orange-100' : 'bg-green-100',
            // title: !auth.hasCompletedProfile() ? 'Your profile is missing required steps' : 'Your profile is ready for approval',
            className: 'bg-orange-100',
            title: 'Your profile has not been submitted for approval. Complete required data and request approval when ready',
            icon: 'fas fa-times-circle text-wripplePrimaryPaleRed',
            subTitle: !auth.hasCompletedProfile() ? 'Missing Required Steps' : 'Ready For Approval',
        }
    }

    return (
        <div className={colClass}>
            <div className="px-3">
                <div className={`talent-dashboard-panel talent-dashboard-feed ${status.className}`}>
                    <div className="talent-panel-content-container flex flex-col sm:flex-row items-center gap-4">
                        <p className="text-black">
                            {status.title}
                        </p>
                        <div className="[&>a]:text-black">
                            <Link to="/talent/application" className="btn py-0 btn-link text-sm text-black" style={{ color: 'black !important' }}>
                                Visit Profile
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}